export default "__VITE_ASSET__NKMtr7s8__"